<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
        <div class="w-full flex flex-col items-center space-y-4 sm:items-end mt-12">
            <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
            <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <div v-if="show && notification" class="max-w-sm w-full bg-white dark:bg-gray-900 shadow-lg border border-racing-stars-yellow rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="w-0 flex-1">
                                <p class="text-sm font-medium text-gray-900 dark:text-white">
                                    {{ notification.title }}
                                </p>
                                <div class="mt-4 flex" v-if="notification.action_text !== ''">
                                    <button  type="button" class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-racing-stars-yellow dark:text-gray-800" @click="doAction()">
                                        {{ notification.action_text }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import { ref, watch, getCurrentInstance } from 'vue'
import { XIcon } from '@heroicons/vue/solid'
import { useStore } from 'vuex'
import { Inertia } from '@inertiajs/inertia'

export default {
    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    components: {
        XIcon,
    },

    setup(props, { emit }) {


        /**
         * The VueX store.
         *
         * @type {Object}
         */
        const store = useStore()

        const notification = ref(null)

        const close = () => {
        	notification.value = null

            emit('close')
        }

        watch(() => props.show, (currentValue, oldValue) => {
        	if (currentValue === true) {
        		setInterval(() => {
	        		let notifications = store.getters.notifications

	        		notification.value = notifications.length ? notifications[0].data : null

	        		setInterval(() => {
	        			notification.value = null

	        			emit('close')
	        		}, 7500)
        		}, )
			}
        })

        const doAction = () => {
            emit('close')

        	Inertia.get(route(notification.value.action_route))

        	notification.value = null
        }

        return {
            close,
            doAction,
            notification,
        }
    },
}

</script>
